import React from "react";
import PropTypes from "prop-types";
import ChargerDetails from "../charger_details/ChargerDetails";
import "./styles.scss";

export default function SlideOutPanel({ open, onClose }) {
  const handleBackdropKeyDown = e => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      if (typeof onClose === "function") onClose();
    }
  };

  return (
    <div className={`ocpp-slideout ${open ? "open" : ""}`} role="dialog" aria-hidden={!open}>
      <div
        className="ocpp-slideout-backdrop"
        role="button"
        tabIndex={0}
        aria-label="Close details"
        onClick={onClose}
        onKeyDown={handleBackdropKeyDown}
      />
      <aside className="ocpp-slideout-panel">
        <div className="ocpp-slideout-body">
          <ChargerDetails onClick={onClose} />
        </div>
      </aside>
    </div>
  );
}

SlideOutPanel.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  serialNumber: PropTypes.string,
  siteId: PropTypes.string,
};

SlideOutPanel.defaultProps = {
  open: false,
  onClose: () => {},
  serialNumber: "",
  siteId: "",
};
